import * as angular from "angular";

export class TalkingPoint {
    public tpcid: any = null;
    public tpcname: any = null;
    public tpid: any = null;
    public tpname: any = null;
    public tptid: any = null;
    public tptimestamp: any = null;
    public tpuid: any = null;
    public team: any = null;
    public category: any = null;

    constructor(data?: any) {
        if (data) {
            this.setData(data);
        }
    }

    setData(data: any): void {
        angular.extend(this, data);
    }
}
